import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
  AppShell,
  NavLink,
  Group,
  Button,
  Text,
  Burger,
  Stack,
} from '@mantine/core';
import {
  IconDashboard,
  IconPackage,
  IconLogout,
  IconShoppingCart,
  IconSettings,
  IconCategory,
} from '@tabler/icons-react';
import { useAuth } from '@/context/AuthContext';
import { notifications } from '@mantine/notifications';

export default function AdminLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [opened, setOpened] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      notifications.show({
        title: 'Logged out',
        message: 'You have been successfully logged out',
        color: 'blue',
      });
      navigate('/xyz/login');
    } catch (error: any) {
      notifications.show({
        title: 'Error',
        message: 'Failed to logout',
        color: 'red',
      });
    }
  };

  const navItems = [
    { icon: IconDashboard, label: 'Dashboard', href: '/xyz' },
    { icon: IconPackage, label: 'Products', href: '/xyz/products' },
    { icon: IconCategory, label: 'Categories', href: '/xyz/categories' },
    { icon: IconShoppingCart, label: 'Orders', href: '/xyz/orders' },
    { icon: IconSettings, label: 'Settings', href: '/xyz/settings' },
  ];

  return (
    <AppShell
      navbar={{
        width: 250,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Navbar p="md">
        <Stack gap="xs">
          <Group justify="space-between" mb="md">
            <Text fw={700} size="lg">
              Admin Panel
            </Text>
            <Burger
              opened={opened}
              onClick={() => setOpened((o) => !o)}
              hiddenFrom="sm"
              size="sm"
            />
          </Group>

          {navItems.map((item) => (
            <NavLink
              key={item.href}
              component={Link}
              to={item.href}
              label={item.label}
              leftSection={<item.icon size={20} />}
              active={location.pathname === item.href}
              onClick={() => {
                navigate(item.href);
                setOpened(false);
              }}
            />
          ))}

          <Group mt="auto" pt="md" style={{ borderTop: '1px solid var(--mantine-color-gray-3)' }}>
            <Text size="sm" c="dimmed">
              {user?.email}
            </Text>
            <Button
              variant="subtle"
              color="red"
              leftSection={<IconLogout size={16} />}
              onClick={handleLogout}
              fullWidth
            >
              Logout
            </Button>
          </Group>
        </Stack>
      </AppShell.Navbar>

      <AppShell.Main>
        {children}
      </AppShell.Main>
    </AppShell>
  );
}

